import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const StyledBox = styled(Box)`
  position: relative;
`;
